module.exports = __webpack_public_path__ + "static/img/i4.f4213935.png";